import { useState } from "react"
import { useSelector } from "react-redux"
import WarningModal from "../components-modals/WarningModal"
import Layout from "../Layout"
import Button from "../components-login/Button"
import { CheckCircleIcon } from "@heroicons/react/24/outline"
import Container from "../components-layout/Container"
const dirWebApp = process.env.REACT_APP_DIR_PRO

const Disclaimer = () => {

    const user = useSelector(state => state.auth.user)
    const [show, setShow] = useState(true)

    return(
        <Layout userObj={JSON.parse(user)} activeTab='Dashboard'>
            <WarningModal
                open={show}
                image={
                    <CheckCircleIcon
                        className="h-14 w-14 text-secundario mx-auto"
                    />
                }
                title='Aviso'
                subtitle={<span>Acceso no permitido!</span>}
                opacity='bg-opacity-50'
            >
                <div className="mt-5 sm:mt-6">
                    <Button
                        onClick={() => {
                            setShow(false)
                            window.location.replace(dirWebApp)
                        }}
                        type="button"
                        className="inline-flex w-full justify-center rounded-md border border-transparent bg-azulBrillanteMira px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-secundario transition duration-500 ease focus:outline-none sm:text-sm"
                    >
                        Entendido
                    </Button>
                </div>
            </WarningModal>
            <Container className='h-full'>
                <div className="h-300"/>
            </Container>
        </Layout>
    )
}

export default Disclaimer